import { combineReducers } from 'redux';

import listSlice from './list';
import formSlice from './form';

export default combineReducers({
  list: listSlice,
  form: formSlice,
});
